import { Box, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useFeatureFlag } from '@internal/plugin-feature-flags-common/components';
import { QETA_BULK_IMPORT_FEATURE_FLAG } from '@internal/plugin-feature-flags-common';
import { QetaFeedbackButton } from './QetaFeedbackButton';
import { QetaBulkImportButton } from './QetaBulkImportButton';

const useStyles = makeStyles(theme => ({
  // Match QetaPage's <Container maxWidth="xl"> so intro actions stay aligned
  // with the main content when the viewport is wide or the page is zoomed out.
  container: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
}));

/**
 * Combined intro buttons for the Qeta page.
 * Includes both Feedback and Bulk Import buttons.
 */
export const QetaIntroButtons = () => {
  const classes = useStyles();
  const { enabled: isBulkImportEnabled } = useFeatureFlag(
    QETA_BULK_IMPORT_FEATURE_FLAG,
  );

  return (
    <Container maxWidth="xl" className={classes.container}>
      <Box className={classes.actions}>
        <QetaFeedbackButton />
        {isBulkImportEnabled && <QetaBulkImportButton />}
      </Box>
    </Container>
  );
};
